export default __webpack_public_path__ + "aws-iot-logo.0ad05b45f120a9c1f4de.png";